<template>
  <footer class="bg-blue-400 pb-10 pt-4 md:pt-20">
    <ContentContainer>
      <div class="flex flex-col md:flex-row justify-between space-y-14 md:space-y-0">
        <div class="lg:flex-grow md:mr-20">
          <img src="@/assets/images/logo-dween.svg"
               alt="DWEEN"
               class="w-full max-w-[791px]"
          />
        </div>

        <div class="flex flex-col items-center space-y-10 md:space-y-0 md:flex-row md:items-start md:space-x-16">
          <div class="flex flex-col justify-between space-y-10 text-center md:text-left">
            <div>
              <h5 class="text-lg font-bold font-inter">
                {{ $t('footer.links.legal') }}
              </h5>

              <div class="mt-6 flex flex-col items-start">
                <router-link class="transition-all font-base text-black-blend font-bold font-inter hover:text-white border-b border-b-transparent hover:border-b-white"
                             to="/terms-conditions"
                >
                  {{ $t('footer.links.terms') }}
                </router-link>

                <router-link class="transition-all font-base text-black-blend font-bold font-inter hover:text-white border-b border-b-transparent hover:border-b-white mt-4"
                             to="/privacy-policy"
                >
                  {{ $t('footer.links.privacy') }}
                </router-link>
              </div>
            </div>

            <div>
              <h5 class="text-lg font-bold font-inter">
                {{ $t('footer.links.needHelp') }}
              </h5>

              <div class="mt-6 flex flex-col items-start space-y-6">
                <router-link class="transition-all font-base text-black-blend font-bold font-inter hover:text-white border-b border-b-transparent hover:border-b-white"
                             to="/contact-us"
                >
                  {{ $t('footer.links.contactUs') }}
                </router-link>
              </div>
            </div>
          </div>

          <!-- Certification -->
          <div class="xl:pr-6">
            <div class="flex flex-row justify-center md:justify-start">
              <img src="@/assets/images/Main_Bureau_veritas.png"
                   class="w-full max-w-[120px] sm:max-w-[180px] md:max-w-[240px]"
              />
            </div>

            <p class="mt-6 font-text text-captions text-black-blend max-w-[307px] text-center md:text-left">
              {{ $t('footer.certification') }}
            </p>
          </div>
        </div>
      </div>

      <!-- Separator line -->
      <div class="mt-10 w-full">
        <svg class="w-full hidden md:block" viewBox="0 0 1760 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="1760" y1="4.62208" x2="-4.37137e-08" y2="4.62191" stroke="black" stroke-width="1.09096"/>
          <ellipse cx="1743.66" cy="4.07672" rx="3.64462" ry="3.81531" transform="rotate(-180 1743.66 4.07672)" fill="black"/>
          <ellipse cx="3.64462" cy="3.81531" rx="3.64462" ry="3.81531" transform="matrix(1 9.53703e-08 8.01375e-08 -1 12.6953 7.89203)" fill="black"/>
          <ellipse cx="1719.69" cy="4.07672" rx="3.64462" ry="3.81531" transform="rotate(-180 1719.69 4.07672)" fill="black"/>
          <ellipse cx="3.64462" cy="3.81531" rx="3.64462" ry="3.81531" transform="matrix(1 9.53703e-08 8.01375e-08 -1 36.6699 7.89203)" fill="black"/>
          <ellipse cx="1685.32" cy="4.07672" rx="3.64462" ry="3.81531" transform="rotate(-180 1685.32 4.07672)" fill="black"/>
          <ellipse cx="3.64462" cy="3.81531" rx="3.64462" ry="3.81531" transform="matrix(1 9.53703e-08 8.01375e-08 -1 71.0352 7.89203)" fill="black"/>
          <ellipse cx="1629.97" cy="4.07672" rx="3.64462" ry="3.81531" transform="rotate(-180 1629.97 4.07672)" fill="black"/>
          <ellipse cx="3.64462" cy="3.81531" rx="3.64462" ry="3.81531" transform="matrix(1 9.53703e-08 8.01375e-08 -1 126.387 7.89203)" fill="black"/>
          <ellipse cx="1549.2" cy="4.07672" rx="3.64462" ry="3.81531" transform="rotate(-180 1549.2 4.07672)" fill="black"/>
          <ellipse cx="3.64462" cy="3.81531" rx="3.64462" ry="3.81531" transform="matrix(1 9.53703e-08 8.01375e-08 -1 207.156 7.89203)" fill="black"/>
          <ellipse cx="1455.85" cy="4.07672" rx="3.64462" ry="3.81531" transform="rotate(-180 1455.85 4.07672)" fill="black"/>
          <ellipse cx="3.64462" cy="3.81531" rx="3.64462" ry="3.81531" transform="matrix(1 9.53703e-08 8.01375e-08 -1 300.51 7.89203)" fill="black"/>
          <ellipse cx="1319.73" cy="4.07672" rx="3.64462" ry="3.81531" transform="rotate(-180 1319.73 4.07672)" fill="black"/>
          <ellipse cx="3.64462" cy="3.81531" rx="3.64462" ry="3.81531" transform="matrix(1 9.53703e-08 8.01375e-08 -1 436.625 7.89203)" fill="black"/>
          <ellipse cx="1138.04" cy="4.07672" rx="3.64462" ry="3.81531" transform="rotate(-180 1138.04 4.07672)" fill="black"/>
          <ellipse cx="3.64462" cy="3.81531" rx="3.64462" ry="3.81531" transform="matrix(1 9.53703e-08 8.01375e-08 -1 618.316 7.89203)" fill="black"/>
          <ellipse cx="879.996" cy="4.07672" rx="3.64462" ry="3.81531" transform="rotate(-180 879.996 4.07672)" fill="black"/>
        </svg>

        <svg class="w-full block md:hidden" viewBox="0 0 302 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M302 5.32791L18 5.32944" stroke="black"/>
          <circle cx="3.5" cy="3.5" r="3.5" transform="matrix(1 9.53703e-08 8.01375e-08 -1 270.641 8.28369)" fill="black"/>
          <circle cx="3.5" cy="3.5" r="3.5" transform="matrix(1 9.53703e-08 8.01375e-08 -1 213.641 8.28369)" fill="black"/>
          <circle cx="3.5" cy="3.5" r="3.5" transform="matrix(1 9.53703e-08 8.01375e-08 -1 156.641 8.28369)" fill="black"/>
          <circle cx="3.5" cy="3.5" r="3.5" transform="matrix(1 9.53703e-08 8.01375e-08 -1 99.6406 8.28369)" fill="black"/>
          <circle cx="3.5" cy="3.5" r="3.5" transform="matrix(1 9.53703e-08 8.01375e-08 -1 42.6406 8.28369)" fill="black"/>
        </svg>
      </div>

      <div class="mt-10 flex flex-col md:flex-row items-center md:justify-between">
        <div class="order-2 md:order-1 mt-6 md:mt-0 font-inter text-base">
          © {{ new Date().getFullYear() }} - DWEEN
        </div>

        <div class="order-1 md:order-2 flex items-center space-x-6">
          <a href="https://youtu.be/NVIDqHu0Pbc"
             target="_blank"
             class="block"
          >
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_2004_33199)">
                <path d="M12.0704 3.89099H12.2039C13.4371 3.89549 19.6855 3.9405 21.3702 4.39356C21.8796 4.53184 22.3437 4.80136 22.7162 5.17519C23.0887 5.54902 23.3566 6.01407 23.4931 6.52387C23.6446 7.09395 23.7511 7.84856 23.8231 8.62717L23.8381 8.78319L23.8711 9.17325L23.8831 9.32927C23.9806 10.7005 23.9926 11.9847 23.9941 12.2652V12.3777C23.9926 12.6687 23.9791 14.0399 23.8711 15.4681L23.8591 15.6257L23.8456 15.7817C23.7706 16.6398 23.6596 17.4919 23.4931 18.119C23.3566 18.6288 23.0887 19.0939 22.7162 19.4677C22.3437 19.8415 21.8796 20.1111 21.3702 20.2493C19.63 20.7174 13.0156 20.7504 12.0989 20.7519H11.8859C11.4223 20.7519 9.50505 20.7429 7.49476 20.6739L7.23973 20.6649L7.10921 20.6589L6.85267 20.6484L6.59613 20.6379C4.93089 20.5644 3.34517 20.4459 2.61456 20.2478C2.10543 20.1097 1.64145 19.8404 1.26895 19.4668C0.896446 19.0933 0.628464 18.6286 0.491759 18.119C0.325235 17.4934 0.214219 16.6398 0.139209 15.7817L0.127207 15.6242L0.115205 15.4681C0.0407396 14.4516 -0.000288447 13.4329 -0.0078125 12.4137L-0.0078125 12.2292C-0.00481207 11.9066 0.00718965 10.792 0.0882013 9.5618L0.0987028 9.40728L0.103203 9.32927L0.115205 9.17325L0.14821 8.78319L0.163212 8.62717C0.235222 7.84856 0.341738 7.09245 0.493259 6.52387C0.629734 6.01407 0.897615 5.54902 1.27013 5.17519C1.64265 4.80136 2.10675 4.53184 2.61606 4.39356C3.34667 4.19854 4.93239 4.07852 6.59763 4.00351L6.85267 3.99301L7.11071 3.984L7.23973 3.9795L7.49626 3.969C8.92403 3.9231 10.3524 3.89759 11.7809 3.89249L12.0704 3.89099ZM9.59356 8.70668V15.9347L15.83 12.3222L9.59356 8.70668Z" fill="black"/>
              </g>
              <defs>
                <clipPath id="clip0_2004_33199">
                  <rect width="24.0034" height="24.0034" fill="white" transform="translate(-0.0078125 0.892212)"/>
                </clipPath>
              </defs>
            </svg>
          </a>

          <a href="https://www.linkedin.com/company/energy-advice/"
             target="_blank"
             class="block"
          >
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.4693 2.89235H3.52685C3.3364 2.88971 3.1473 2.9246 2.97034 2.99505C2.79338 3.0655 2.63203 3.17011 2.4955 3.30292C2.35898 3.43573 2.24995 3.59414 2.17465 3.76909C2.09935 3.94404 2.05925 4.13211 2.05664 4.32256V21.465C2.05925 21.6555 2.09935 21.8435 2.17465 22.0185C2.24995 22.1934 2.35898 22.3518 2.4955 22.4846C2.63203 22.6175 2.79338 22.7221 2.97034 22.7925C3.1473 22.863 3.3364 22.8979 3.52685 22.8952H20.4693C20.6597 22.8979 20.8488 22.863 21.0258 22.7925C21.2028 22.7221 21.3641 22.6175 21.5006 22.4846C21.6372 22.3518 21.7462 22.1934 21.8215 22.0185C21.8968 21.8435 21.9369 21.6555 21.9395 21.465V4.32256C21.9369 4.13211 21.8968 3.94404 21.8215 3.76909C21.7462 3.59414 21.6372 3.43573 21.5006 3.30292C21.3641 3.17011 21.2028 3.0655 21.0258 2.99505C20.8488 2.9246 20.6597 2.88971 20.4693 2.89235ZM8.0875 19.6348H5.08707V10.6335H8.0875V19.6348ZM6.58729 9.37328C6.17349 9.37328 5.77664 9.2089 5.48405 8.9163C5.19145 8.6237 5.02707 8.22685 5.02707 7.81306C5.02707 7.39926 5.19145 7.00241 5.48405 6.70981C5.77664 6.41721 6.17349 6.25283 6.58729 6.25283C6.80702 6.22791 7.02953 6.24969 7.24026 6.31673C7.45099 6.38376 7.64518 6.49456 7.81012 6.64185C7.97506 6.78914 8.10703 6.96961 8.19739 7.17145C8.28775 7.37328 8.33446 7.59192 8.33446 7.81306C8.33446 8.03419 8.28775 8.25283 8.19739 8.45467C8.10703 8.6565 7.97506 8.83697 7.81012 8.98426C7.64518 9.13156 7.45099 9.24235 7.24026 9.30939C7.02953 9.37643 6.80702 9.3982 6.58729 9.37328ZM18.9091 19.6348H15.9086V14.8041C15.9086 13.5939 15.4786 12.8038 14.3884 12.8038C14.051 12.8062 13.7225 12.9121 13.4471 13.107C13.1717 13.3019 12.9627 13.5766 12.8482 13.8939C12.7699 14.129 12.736 14.3766 12.7482 14.624V19.6247H9.74774V10.6235H12.7482V11.8936C13.0207 11.4207 13.4172 11.031 13.8948 10.7667C14.3724 10.5023 14.9131 10.3733 15.4586 10.3934C17.4588 10.3934 18.9091 11.6836 18.9091 14.454V19.6348Z" fill="black"/>
            </svg>
          </a>
        </div>
      </div>
    </ContentContainer>

    <CookiesAccept />
  </footer>
</template>

<script>
import CookiesAccept from "@/components/CookiesAccept";
import ContentContainer from "@/components/ui/ContentContainer.vue";

export default {
  name: "TheFooter",

  components: {
    ContentContainer,
    CookiesAccept,
  },

};
</script>
